import { css } from '@emotion/react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import analytics from '../services/analytics'

export default function Header() {
  const data = useStaticQuery(graphql`
    {
      file(relativePath: { eq: "atlassian-logo.png" }) {
        childImageSharp {
          gatsbyImageData(width: 190, placeholder: NONE, layout: FIXED)
        }
      }
    }
  `)

  return (
    <header className='page-header'>
      <div
        css={css`
          padding: 0 20px;
        `}
      >
        <a
          css={css`
            display: flex;
          `}
          href='https://atlassian.com'
          rel='noreferrer'
          target='_blank'
        >
          <GatsbyImage
            alt='Atlassian logo'
            image={getImage(data.file)}
            onClick={() => analytics.events.atlLinkClick('logo')}
          />
        </a>
      </div>
    </header>
  )
}
